{
	"name": "@ikegps/core-api",
	"version": "16.93.3",
	"description": "",
	"keywords": [],
	"license": "UNLICENSED",
	"author": "devops@ikegps.com",
	"main": "build/src/index.js",
	"typings": "build/src/index.d.ts",
	"scripts": {
		"build": "yarn generate:types && tsc -p tsconfig.build.json",
		"build-clean": "rm -fr build/ && npm run build",
		"build-docs": "yarn build; cd ../office-server; yarn build",
		"docs:generate:openapi": "node ./scripts/write.openapi.schema.js;",
		"generate:types": "yarn openapi-typescript",
		"test": "vp test run",
		"test-ci": "vp test run --reporter=junit --outputFile=../../test-reports/$npm_package_name.xml"
	},
	"dependencies": {
		"joi": "^17.7.0",
		"joi-to-swagger": "^6.2.0"
	},
	"devDependencies": {
		"ajv": "^5.2.2",
		"openapi-schema-validator": "^12.1.3",
		"openapi-typescript": "^7.7.1",
		"typescript": "^5.9.3"
	},
	"engines": {
		"node": "22.19.0"
	}
}
